class Tools {
  constructor() {

    this.getDaysInMonth = this.getDaysInMonth.bind(this);
    this.validateWholeDate = this.validateWholeDate.bind(this);
  }

  capitalizeName(data, fieldName) {
    let newData = [];
    let name = '';
    data.map((item) => {
      if (item[fieldName]) {
        name = item[fieldName].toLowerCase().split(' ')
          .map((word) => {
            return (word.charAt(0).toUpperCase() + word.slice(1));
          });
        item[fieldName] = name.join(' ');
        newData.push(item);
      }
    });
    return newData;
  }

  setNameToCapitalize(upperCaseName) {
    let name = '';
    name = upperCaseName.toLowerCase().split(' ')
      .map((word) => {
        return (word.charAt(0).toUpperCase() + word.slice(1));
      });
    upperCaseName = name.join(' ');
    return upperCaseName;
  }

  setContentType() {
    let contentType = 'Anonimo';
    if (!compTools.autenticadoWindows() && compTools.estaAutenticado()) {
      const authenticatedUser = compTools.obtenerInformacionUsuario();
      if (authenticatedUser['ValidacionDerechos'] && authenticatedUser.Error === null) {
        const validarDerechosCliente = authenticatedUser['ValidacionDerechos'];
        contentType = validarDerechosCliente.Programa !== 'CE' || validarDerechosCliente.Programa !== 'EP' ? validarDerechosCliente.Programa : 'Anonimo';
      }
    }
    return contentType;
  }

  isAuthenticated() {
    if (compTools.estaAutenticado()) {
      return true;
    }
    return false;
  }

  isAsesor() {
    const validationService = new ServicioProxy('ObtenerTipoUsuario', 'ServicioConsorcio.svc'); return new Promise((resolve, reject) => {
      validationService.getElements('POST', {})
        .then(isAsesor => {
          resolve(isAsesor);
        })
        .catch(error => reject(error));
    })
  }

  getBase64(file) {
    const reader = new FileReader();
    let base64File = '';
    reader.readAsDataURL(file);

    return new Promise((resolve, reject) => {
      reader.onload = function () {
        base64File = reader.result;

        resolve(base64File);
      }

      reader.onerror = function (error) {
        reject(error);
      }

    });
  }

  handleInputChange(event) {
    let inputValue = '';
    if (event) {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
      inputValue = value;
    }
    return inputValue;
  }

  handleSwitch(selected, field) {
    const valueSelected = selected ? true : false;
    return valueSelected;
  }

  getDaysInMonth(month, year) {
    switch (month) {
      case 2:
        return (year % 4 == 0 && year % 100) || year % 400 == 0 ? 29 : 28;
      case 9: case 4: case 6: case 11:
        return 30;
      default:
        return 31
    }
  }
  validateWholeDate(d, m, y) {
    return m >= 0 && m <= 12 && y >= 0 && d >= 0 && d <= this.getDaysInMonth(m, y);
  }

  getLoginURL(param) {
    if (param) {
      const splitParam = param.split('|');

      return location.protocol == 'https:' ? (window.location.origin + '/_trust/default.aspx?trust=' + splitParam[1] + '&ReturnUrl=' + window.location.pathname) : (window.location.origin + '/_layouts/15/Authenticate.aspx?Source=' + document.location.href);
    } else {
      return '';
    }
  }
  isOnlyNumbers(text) {
    if (/^[0-9]*$/.test(text) && text !== '') {
      return true;
    } else {
      return false;
    }
  }
  isOnlyNumbersWithCurrency(text) {
    if (/^[0-9$.]*$/.test(text) && text !== '') {
      return true;
    } else {
      return false;
    }
  }
  /*
  Funcion que ordena una lista de objetos por una propiedad especifica dada, y en un orden dado
  @params list - Array a ordenar
  @params property - String de la propiedad de cada objeto item del arreglo por la que se quiere ordenar
  @params order - boolean: true - ordenar ascendentemente, false - ordenar descendentemente
  @return orderedArray - Array ordenado
  */
  sortByProperty(list, property, order) {
    let value = 0;
    return list.sort((a, b) => {
      if (typeof a[property] === 'string' && typeof b[property] === 'string') {
        a[property] = a[property].toUpperCase();
        b[property] = b[property].toUpperCase();
      }

      if (a[property] < b[property]) {
        value = order ? -1 : 1;
      }
      if (a[property] > b[property]) {
        value = order ? 1 : -1;
      }

      return value;
    })
  }


  /* Handle scroll */
  handleScroll(event, propsTabIndex = 1, id = '') {
    const addClass = (el, className) => {
      if (el.classList)
        el.classList.add(className);
      else
        el.className += ' ' + className;
    }
    const removeClass = (el, className) => {
      if (el.classList)
        el.classList.remove(className);
      else
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
    $('.popover').hide();
    const tabIndex = !id ? propsTabIndex - 1 : 0;
    const actualId = id ? `#${id}` : '';
    const itemScroll = document.querySelectorAll(`${actualId}.tableContentBorder`)[tabIndex];

    const scrollLeftMax = itemScroll.scrollWidth - itemScroll.clientWidth;
    const dist = Math.round(2 * itemScroll.scrollLeft / scrollLeftMax);
    const min = dist === 0 ? 'first' : dist === 1 ? 'second' : 'third';
    const activeDots = document.querySelectorAll(`.scroll_item.tab_${propsTabIndex}`);
    activeDots.forEach(dot => {
      if (dot.id === min) {
        addClass(dot, 'scroll_active');
      } else {
        removeClass(dot, 'scroll_active');
      }
    })
  }

  /*
  Funcion que realiza un scroll a un elemento dado, con un tiempo de animación dado
  @params elemnt - string con el elemento para hacer scroll
  @params duration - number con la cantidad de milisegundos que se quiere que dura la animación
  */
  scrollToDiv(element, duration) {
    $('html, body').animate({
      scrollTop: $(`#${element}`).position().top
    }, duration);
  }
  /*
  Funcion que formatea un string dandole un formato de moneda: agrega el signo $ y le pone un separador de miles
  @params text - string numero a formatear
  @params separator - string con el separador de miles que se quiere poner. por defecto = '.'
  @return formattedString - string con el numero formatead
  */
  textToCurrency(text, separator = '.') {
    return text ? `$${text.replace(/\B(?=(\d{3})+(?!\d))/g, separator)}` : '';
  }
  validateEmailInput(text) {
    const re = /^(([^<>()[\]{\}\\\/.,;:#$%&=~+¿?¡!^*¨'`´áéíóúñÁÉÍÓÚÑ\s@\"]+(\.[^<>()[\]{\}\\\/.,;:#$%&=~+¿?¡!^*¨'`´áéíóúñÁÉÍÓÚ\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

    return re.test(String(text).toLowerCase());
  }
}

export default Tools;